(function () {
  if (window.originalReservationProductInitialized) return;
  window.originalReservationProductInitialized = true;

  const APP_MODAL_SELECTOR = '.cowlendar-modal';
  const WIDGET_SELECTOR = '#shopify-cowlendar-widget';
  const WIDGET_ROOT_SELECTOR = '#widget-root';
  const APP_BUTTON_SELECTOR = '.cowlendar-btn';
  const OWNER_OPTION_VALUE_ID = '5341860724981';
  const EMPLOYEE_OPTION_VALUE_ID = '5341863117045';
  const ROOT_SELECTOR = '[data-original-reservation-product]';
  const PRODUCT_INFO_SELECTOR = '.product__info-container';
  const CONTROLS_CLASS = 'cowlendar-product-controls';
  const OPEN_BUTTON_CLASS = 'cowlendar-custom-open';
  const CUSTOM_MODAL_CLASS = 'cowlendar-custom-modal';
  const CUSTOM_MODAL_OPEN_CLASS = 'cowlendar-custom-modal-open';
  const APP_MODAL_REQUESTED_CLASS = 'ariafina-cowlendar-requested';
  const APP_MODAL_FORCED_CLOSED_ATTRIBUTE = 'data-ariafina-forced-closed';
  const CART_GUARD_CLASS = 'cowlendar-cart-guard';

  const sessions = new Map();
  let activeSession = null;
  let customModal = null;
  let customModalContent = null;
  let waitingForAppModal = false;
  let keepControlsInAppModalUntil = 0;
  let homeOpenRequested = false;
  let homeReservationRequiresEligibleAccount = true;
  const observedAppModalRoots = new WeakSet();

  function injectStyles() {
    if (document.getElementById('cowlendar-custom-modal-style')) return;

    const style = document.createElement('style');
    style.id = 'cowlendar-custom-modal-style';
    style.textContent = `
      .${CUSTOM_MODAL_CLASS}[hidden] {
        display: none !important;
      }

      .${CUSTOM_MODAL_CLASS} {
        align-items: center;
        background: rgba(0, 0, 0, 0.48);
        display: flex;
        inset: 0;
        justify-content: center;
        padding: 20px;
        position: fixed;
        z-index: 2147483000;
      }

      .${CUSTOM_MODAL_CLASS}__dialog {
        background: rgb(var(--color-background, 255, 255, 255));
        border-radius: 8px;
        box-shadow: 0 18px 50px rgba(0, 0, 0, 0.25);
        color: rgb(var(--color-foreground, 18, 18, 18));
        max-height: min(760px, calc(100vh - 40px));
        max-width: 720px;
        overflow: auto;
        padding: 24px;
        position: relative;
        width: min(100%, 720px);
      }

      .${CUSTOM_MODAL_CLASS}__close {
        align-items: center;
        appearance: none;
        background: transparent;
        border: 0;
        color: currentColor;
        cursor: pointer;
        display: flex;
        font-size: 28px;
        height: 40px;
        justify-content: center;
        line-height: 1;
        padding: 0;
        position: absolute;
        right: 8px;
        top: 8px;
        width: 40px;
      }

      .${CUSTOM_MODAL_CLASS}__content {
        padding-top: 20px;
      }

      .${CONTROLS_CLASS} {
        display: grid;
        gap: 16px;
        margin-bottom: 18px;
      }

      .${CONTROLS_CLASS} .product-form {
        margin: 0;
      }

      .${CONTROLS_CLASS} .product-form__buttons {
        max-width: none;
      }

      .cowlendar-bg.cowlendar-root.${APP_MODAL_REQUESTED_CLASS} {
        align-items: center;
        flex-direction: column;
        gap: 0;
        justify-content: center;
      }

      .cowlendar-bg > .${CONTROLS_CLASS} {
        align-items: stretch;
        display: flex;
        gap: var(--space-20);
        margin: 0;
      }

      .cowlendar-bg > .${CONTROLS_CLASS} variant-selects {
        display: block;
        flex: 1 1 auto;
        min-width: 0;
      }

      .cowlendar-bg > .${CONTROLS_CLASS} .product-form__input {
        border: 0;
        height: 100%;
        margin: 0;
        padding: 0;
        width: 100%;
      }

      .cowlendar-bg > .${CONTROLS_CLASS} .form__label {
        display: none;
      }

      .cowlendar-bg > .${CONTROLS_CLASS} .select {
        width: 100%;
      }

      .cowlendar-bg > .${CONTROLS_CLASS} .select__select {
        width: 100%;
      }

      .cowlendar-bg > .${CONTROLS_CLASS} > div,
      .cowlendar-bg > .${CONTROLS_CLASS} .product-form,
      .cowlendar-bg > .${CONTROLS_CLASS} .product-form form,
      .cowlendar-bg > .${CONTROLS_CLASS} .product-form__buttons {
        height: 100%;
        margin: 0;
        max-width: none;
      }

      .cowlendar-bg > .${CONTROLS_CLASS} .cowlendar-product-form-block {
        display: none !important;
      }

      @media screen and (max-width: 980px) {
        .cowlendar-bg > .${CONTROLS_CLASS} {
          max-width: 700px;
          width: calc(100% - var(--margin-side) * 2);
        }
      }

      @media screen and (min-width: 981px) {
        .cowlendar-bg > .${CONTROLS_CLASS} {
          min-width: 700px;
          width: calc((100% - var(--margin-side) * 2) / 2 - 0.75px + 1px);
        }
      }

      body.${CUSTOM_MODAL_OPEN_CLASS} {
        overflow: hidden;
      }

      .cowlendar-login-required {
        margin-top: 1.2rem;
      }

      @media screen and (max-width: 749px) {
        .${CUSTOM_MODAL_CLASS} {
          align-items: flex-end;
          padding: 0;
        }

        .${CUSTOM_MODAL_CLASS}__dialog {
          border-radius: 8px 8px 0 0;
          max-height: 90vh;
          max-width: none;
          padding: 20px;
          width: 100%;
        }
      }

      .${CART_GUARD_CLASS}[hidden] {
        display: none !important;
      }

      .${CART_GUARD_CLASS} {
        align-items: center;
        background: rgba(0, 0, 0, 0.48);
        display: flex;
        inset: 0;
        justify-content: center;
        padding: 20px;
        position: fixed;
        z-index: 2147483001;
      }

      .${CART_GUARD_CLASS}__dialog {
        background: var(--color-white, #fff);
        color: var(--color-black, #1a1a1a);
        max-width: 460px;
        padding: 40px 32px 32px;
        position: relative;
        width: min(100%, 460px);
      }

      .${CART_GUARD_CLASS}__close {
        align-items: center;
        appearance: none;
        background: transparent;
        border: 0;
        color: currentColor;
        cursor: pointer;
        display: flex;
        font-size: 26px;
        height: 40px;
        justify-content: center;
        line-height: 1;
        padding: 0;
        position: absolute;
        right: 4px;
        top: 4px;
        width: 40px;
      }

      .${CART_GUARD_CLASS}__title {
        font-size: 16px;
        font-weight: 600;
        margin: 0 0 12px;
        text-align: center;
      }

      .${CART_GUARD_CLASS}__note {
        font-size: 12px;
        line-height: 1.8;
        margin: 0 0 24px;
        text-align: center;
      }

      .${CART_GUARD_CLASS}__buttons {
        display: grid;
        gap: 8px;
      }

      .${CART_GUARD_CLASS}__button {
        appearance: none;
        border: solid 1px var(--color-darkgray, #333);
        cursor: pointer;
        font: inherit;
        font-size: 14px;
        padding: 14px 20px;
        text-align: center;
        transition: background-color 0.2s ease, color 0.2s ease;
        width: 100%;
      }

      .${CART_GUARD_CLASS}__button--primary {
        background: var(--color-darkgray, #333);
        color: var(--color-white, #fff);
      }

      .${CART_GUARD_CLASS}__button--primary:hover {
        background: var(--color-white, #fff);
        color: var(--color-black, #1a1a1a);
      }

      .${CART_GUARD_CLASS}__button--secondary {
        background: var(--color-white, #fff);
        color: var(--color-black, #1a1a1a);
      }

      .${CART_GUARD_CLASS}__button--secondary:hover {
        background: var(--color-lightgray, #eee);
      }

      .${CART_GUARD_CLASS}__button[disabled] {
        cursor: default;
        opacity: 0.5;
        pointer-events: none;
      }
    `;
    document.head.append(style);
  }

  function createCustomModal() {
    if (customModal) return;

    customModal = document.createElement('div');
    customModal.className = CUSTOM_MODAL_CLASS;
    customModal.hidden = true;
    customModal.innerHTML = `
      <div class="${CUSTOM_MODAL_CLASS}__dialog" role="dialog" aria-modal="true" aria-label="予約フォーム">
        <button class="${CUSTOM_MODAL_CLASS}__close" type="button" aria-label="閉じる">&times;</button>
        <div class="${CUSTOM_MODAL_CLASS}__content"></div>
      </div>
    `;
    customModalContent = customModal.querySelector(`.${CUSTOM_MODAL_CLASS}__content`);
    document.body.append(customModal);

    customModal.addEventListener('click', (event) => {
      if (event.target === customModal || event.target.closest(`.${CUSTOM_MODAL_CLASS}__close`)) {
        closeCustomModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && customModal && !customModal.hidden) {
        closeCustomModal();
      }
    });
  }

  function getProductControls(productInfo) {
    /* 予約商品が単一variant（has_only_default_variant）の場合、Dawnは
       variant-selectsを出力しない。エリア選択UIは廃止済みのため必須にしない。 */
    const variantSelects = productInfo.querySelector('variant-selects');
    const productForm = productInfo.querySelector('product-form');

    if (!productForm) return null;

    return {
      variantSelects,
      productFormBlock: productForm.parentElement && productForm.parentElement !== productInfo ? productForm.parentElement : productForm,
      appButton: productForm.querySelector(APP_BUTTON_SELECTOR),
    };
  }

  function buildOpenButton(appButton) {
    const openButton = appButton.cloneNode(true);
    const appButtonClasses = Array.from(openButton.classList).filter((className) => className.indexOf('cowlendar-btn') === 0);

    openButton.type = 'button';
    openButton.removeAttribute('id');
    openButton.removeAttribute('name');
    openButton.removeAttribute('style');
    if (appButtonClasses.length > 0) {
      openButton.classList.remove(...appButtonClasses);
    }
    openButton.classList.add(OPEN_BUTTON_CLASS);
    openButton.setAttribute('aria-haspopup', 'dialog');
    return openButton;
  }

  /* ============================================================
     カート重複予約ガード
     カートに商品（＝お手続き中の予約）が残っている状態で新しい予約を
     開始しようとした場合、確認ポップアップを表示する。
     ・「予約を削除して新しく予約する」→ カートを空にして予約フォームを開く
     ・「予約を確認する」→ カートページへ遷移
     ============================================================ */
  let cartGuardModal = null;
  let cartGuardPendingSession = null;
  let cartGuardBusy = false;

  function ensureCartGuardModal() {
    if (cartGuardModal) return cartGuardModal;

    cartGuardModal = document.createElement('div');
    cartGuardModal.className = CART_GUARD_CLASS;
    cartGuardModal.hidden = true;
    cartGuardModal.innerHTML = `
      <div class="${CART_GUARD_CLASS}__dialog" role="dialog" aria-modal="true" aria-label="確認">
        <button class="${CART_GUARD_CLASS}__close" type="button" aria-label="閉じる">&times;</button>
        <p class="${CART_GUARD_CLASS}__title">完了していない予約があります</p>
        <p class="${CART_GUARD_CLASS}__note">新しく予約する場合は、お手続き中の予約を削除する必要があります。</p>
        <div class="${CART_GUARD_CLASS}__buttons">
          <button class="${CART_GUARD_CLASS}__button ${CART_GUARD_CLASS}__button--primary" type="button" data-cart-guard-clear>予約を削除して新しく予約する</button>
          <button class="${CART_GUARD_CLASS}__button ${CART_GUARD_CLASS}__button--secondary" type="button" data-cart-guard-cart>予約を確認する</button>
        </div>
      </div>
    `;
    document.body.append(cartGuardModal);

    cartGuardModal.addEventListener('click', (event) => {
      if (cartGuardBusy) return;

      if (event.target === cartGuardModal || event.target.closest(`.${CART_GUARD_CLASS}__close`)) {
        closeCartGuardModal();
        return;
      }

      if (event.target.closest('[data-cart-guard-cart]')) {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        return;
      }

      if (event.target.closest('[data-cart-guard-clear]')) {
        clearCartAndProceed();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && cartGuardModal && !cartGuardModal.hidden && !cartGuardBusy) {
        closeCartGuardModal();
      }
    });

    return cartGuardModal;
  }

  function openCartGuardModal(session) {
    ensureCartGuardModal();
    cartGuardPendingSession = session;
    cartGuardModal.hidden = false;
  }

  function closeCartGuardModal() {
    if (!cartGuardModal) return;
    cartGuardModal.hidden = true;
    cartGuardPendingSession = null;
  }

  function setCartGuardBusy(busy) {
    cartGuardBusy = busy;
    if (!cartGuardModal) return;
    cartGuardModal.querySelectorAll(`.${CART_GUARD_CLASS}__button`).forEach((button) => {
      if (busy) {
        button.setAttribute('disabled', 'disabled');
      } else {
        button.removeAttribute('disabled');
      }
    });
  }

  function clearReservationCart() {
    return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' }).then((response) => {
      if (!response.ok) throw new Error('cart clear failed');
    });
  }

  function clearCartAndProceed() {
    const session = cartGuardPendingSession;
    if (!session) return;

    setCartGuardBusy(true);

    clearReservationCart()
      .then(() => {
        setCartGuardBusy(false);
        closeCartGuardModal();
        openCustomModalNow(session);
      })
      .catch(() => {
        setCartGuardBusy(false);
        window.alert('予約の削除に失敗しました。ページを再読み込みして再度お試しください。');
      });
  }

  function fetchCartItemCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => (cart && typeof cart.item_count === 'number' ? cart.item_count : 0))
      .catch(() => 0);
  }

  function setExistingReservationBusy(busy) {
    const modal = document.querySelector('#modal[data-content="reservation_in_cart"]');
    if (!modal) return;

    modal.setAttribute('aria-busy', busy ? 'true' : 'false');
    modal.querySelectorAll('[data-existing-reservation-continue], [data-existing-reservation-new]').forEach((button) => {
      button.classList.toggle('disabled', busy);
      if (busy) {
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-disabled');
      }
    });
  }

  function clearExistingReservationAndProceed(requiresEligibleAccount) {
    const session = Array.from(sessions.values()).find(
      (candidate) => !requiresEligibleAccount || canOpenReservation(candidate.productInfo),
    );
    if (!session) return;

    setExistingReservationBusy(true);

    clearReservationCart()
      .then(() => {
        if (typeof window.closeModal === 'function') window.closeModal();
        document.querySelectorAll('[data-original-existing-reservation-link]').forEach((link) => {
          link.hidden = true;
        });
        document.querySelectorAll('[data-original-reservation-in-cart]').forEach((link) => {
          link.removeAttribute('data-original-reservation-in-cart');
        });
        openCustomModalNow(session);
      })
      .catch(() => {
        setExistingReservationBusy(false);
        window.alert('予約の削除に失敗しました。ページを再読み込みして再度お試しください。');
      });
  }

  function openCustomModal(session) {
    fetchCartItemCount().then((itemCount) => {
      if (itemCount > 0) {
        openCartGuardModal(session);
      } else {
        openCustomModalNow(session);
      }
    });
  }

  function openCustomModalNow(session) {
    createCustomModal();
    activeSession = session;
    waitingForAppModal = false;
    keepControlsInAppModalUntil = 0;

    if (customModal.parentNode !== session.productInfo) {
      session.productInfo.append(customModal);
    }
    if (session.controlsWrapper.parentNode !== customModalContent) {
      customModalContent.append(session.controlsWrapper);
    }

    applyOptionVisibility(session);
    selectFirstVisibleOption(session);
    enableCalendarButton(session);
    openSelectedCalendar(session);
  }

  function closeCustomModal() {
    if (!customModal) return;

    customModal.hidden = true;
    document.body.classList.remove(CUSTOM_MODAL_OPEN_CLASS);
  }

  function getAppModal() {
    const modals = Array.from(document.querySelectorAll(APP_MODAL_SELECTOR));
    return (
      modals.find((modal) => modal.querySelector(`.${CONTROLS_CLASS}`)) ||
      modals.find((modal) => modal.querySelector(WIDGET_SELECTOR) || modal.querySelector('iframe')) ||
      null
    );
  }

  /* HTML実装（.cowlendar-bg > .cowlendar_selector + .cowlendar-modal）に合わせ、
     エリア選択バーはカレンダーモーダルの中ではなく直前の兄弟として配置する。
     bgルートが見つからない場合のみ従来通りモーダル先頭に入れる。 */
  function mountControlsAboveAppModal(appModal, controlsWrapper) {
    const appModalRoot = appModal.closest('.cowlendar-bg.cowlendar-root');
    if (appModalRoot) {
      if (controlsWrapper.parentNode !== appModalRoot || controlsWrapper.nextElementSibling !== appModal) {
        appModalRoot.insertBefore(controlsWrapper, appModal);
      }
      return;
    }
    if (appModal.firstElementChild !== controlsWrapper) {
      appModal.prepend(controlsWrapper);
    }
  }

  function moveControlsToAppModal() {
    if (!activeSession) return;

    const appModal = getAppModal();
    if (!appModal) return;

    const appModalRoot = appModal.closest('.cowlendar-bg.cowlendar-root');
    if (appModalRoot) {
      appModalRoot.classList.add(APP_MODAL_REQUESTED_CLASS);
    }

    mountControlsAboveAppModal(appModal, activeSession.controlsWrapper);
    waitingForAppModal = false;
    closeCustomModal();
  }

  function holdControlsInAppModal(duration = 2500) {
    keepControlsInAppModalUntil = Date.now() + duration;
  }

  function shouldKeepControlsInAppModal() {
    return waitingForAppModal || Date.now() < keepControlsInAppModalUntil;
  }

  function restoreControlsToCustomModal() {
    if (!activeSession || !customModalContent) return;
    if (activeSession.controlsWrapper.parentNode === customModalContent) return;

    customModalContent.append(activeSession.controlsWrapper);
  }

  function appModalRootIsClosed(appModalRoot) {
    return (
      appModalRoot.hidden ||
      appModalRoot.getAttribute('aria-hidden') === 'true' ||
      appModalRoot.style.display === 'none'
    );
  }

  function resetAppModalState(appModalRoot) {
    waitingForAppModal = false;
    keepControlsInAppModalUntil = 0;
    appModalRoot.classList.remove(APP_MODAL_REQUESTED_CLASS);
    if (!appModalRoot.hasAttribute(APP_MODAL_FORCED_CLOSED_ATTRIBUTE)) {
      appModalRoot.setAttribute(APP_MODAL_FORCED_CLOSED_ATTRIBUTE, 'true');
      appModalRoot.style.setProperty('display', 'none', 'important');
    }
    restoreControlsToCustomModal();
  }

  function prepareAppModalRootsToOpen() {
    document
      .querySelectorAll(`.cowlendar-bg.cowlendar-root[${APP_MODAL_FORCED_CLOSED_ATTRIBUTE}]`)
      .forEach((appModalRoot) => {
        appModalRoot.removeAttribute(APP_MODAL_FORCED_CLOSED_ATTRIBUTE);
        appModalRoot.style.removeProperty('display');
        appModalRoot.hidden = false;
        appModalRoot.removeAttribute('aria-hidden');
      });
  }

  const appModalStateObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const appModalRoot = mutation.target;
      if (appModalRootIsClosed(appModalRoot)) {
        resetAppModalState(appModalRoot);
      }
    });
  });

  function observeAppModalRoots() {
    document.querySelectorAll('.cowlendar-bg.cowlendar-root').forEach((appModalRoot) => {
      if (observedAppModalRoots.has(appModalRoot)) return;

      observedAppModalRoots.add(appModalRoot);
      appModalStateObserver.observe(appModalRoot, {
        attributes: true,
        attributeFilter: ['style', 'hidden', 'aria-hidden'],
      });
    });
  }

  function getWidgetCloseControl(target) {
    if (!(target instanceof Element)) return null;

    const widgetRoot = target.closest(WIDGET_ROOT_SELECTOR);
    const closeCross = target.closest('[class*="Widget__CloseCross-sc-"]');
    if (widgetRoot && closeCross && widgetRoot.contains(closeCross)) return closeCross;

    const control = target.closest('button, [role="button"], a');
    if (!widgetRoot || !control || !widgetRoot.contains(control)) return null;

    const label = [
      control.getAttribute('aria-label'),
      control.getAttribute('title'),
      control.getAttribute('data-testid'),
      typeof control.className === 'string' ? control.className : '',
      control.textContent,
    ]
      .filter(Boolean)
      .join(' ')
      .trim()
      .toLowerCase();

    return /(^|[\s_-])(close|dismiss)([\s_-]|$)/.test(label) || /^(閉じる|×|✕|x)$/.test(label) ? control : null;
  }

  function closeAppModalFromWidget(widgetRoot) {
    const appModalRoot = widgetRoot.closest('.cowlendar-bg.cowlendar-root');
    if (appModalRoot) {
      resetAppModalState(appModalRoot);
      return;
    }

    waitingForAppModal = false;
    keepControlsInAppModalUntil = 0;
    restoreControlsToCustomModal();
  }

  function scheduleMoveToAppModal() {
    window.requestAnimationFrame(() => {
      moveControlsToAppModal();
      window.setTimeout(moveControlsToAppModal, 150);
      window.setTimeout(moveControlsToAppModal, 500);
      window.setTimeout(moveControlsToAppModal, 1000);
    });
  }

  function findSessionByAppButton(appButton) {
    return Array.from(sessions.values()).find((session) => session.appButton === appButton) || null;
  }

  function findSessionByNode(node) {
    return Array.from(sessions.values()).find((session) => session.controlsWrapper.contains(node)) || null;
  }

  function getVisibleOptions(select) {
    return Array.from(select.options).filter((option) => !option.disabled && !option.hidden);
  }

  function selectOption(select, option) {
    const isAlreadySelected = select.selectedIndex === option.index && option.selected && option.hasAttribute('selected');
    if (isAlreadySelected) return false;

    Array.from(select.options).forEach((selectOption) => {
      selectOption.selected = false;
      selectOption.removeAttribute('selected');
    });
    option.selected = true;
    option.setAttribute('selected', 'selected');
    select.selectedIndex = option.index;
    select.value = option.value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function getVariantData(session) {
    if (session.variantData) return session.variantData;

    const script = session.productInfo.closest(ROOT_SELECTOR)?.querySelector('[data-original-reservation-variants]');
    if (!script) {
      session.variantData = [];
      return session.variantData;
    }

    try {
      session.variantData = JSON.parse(script.textContent);
    } catch (error) {
      session.variantData = [];
    }

    return session.variantData;
  }

  function getCustomerAccountType(session) {
    const root = session.productInfo.closest(ROOT_SELECTOR);
    return root ? (root.dataset.customerAccountType || '').trim().toLowerCase() : '';
  }

  function customerState(productInfo) {
    const root = productInfo.closest(ROOT_SELECTOR);
    return {
      loggedIn: Boolean(root && root.dataset.customerLoggedIn === 'true'),
      accountType: root ? (root.dataset.customerAccountType || '').trim().toLowerCase() : '',
    };
  }

  function canOpenReservation(productInfo) {
    const state = customerState(productInfo);
    if (!state.loggedIn) return true;
    return state.accountType === 'customer' || state.accountType === 'employee';
  }

  function shouldShowOption(option, accountType) {
    const isOwnerOnlyOption = option.dataset.optionValueId === OWNER_OPTION_VALUE_ID;
    const isEmployeeOnlyOption = option.dataset.optionValueId === EMPLOYEE_OPTION_VALUE_ID;

    if (accountType === 'owner' || accountType === '') {
      return isOwnerOnlyOption;
    }

    if (isOwnerOnlyOption) {
      return false;
    }

    if (isEmployeeOnlyOption && accountType !== 'employee') {
      return false;
    }

    return true;
  }

  function applyOptionVisibility(session) {
    const accountType = getCustomerAccountType(session);
    const selects = session.controlsWrapper.querySelectorAll('select');
    /* エリア選択UIは全アカウント種別で非表示。optionの絞り込みと自動選択は
       アカウント種別ごとの予約variant決定に使うため維持する。 */
    const hideControls = true;

    session.controlsWrapper.hidden = hideControls;
    session.controlsWrapper.style.display = hideControls ? 'none' : '';

    selects.forEach((select) => {
      const options = Array.from(select.options);
      let selectedOptionIsVisible = true;

      options.forEach((option) => {
        const showOption = shouldShowOption(option, accountType);
        option.hidden = !showOption;
        option.disabled = !showOption;
        option.style.display = showOption ? '' : 'none';

        if ((option.selected || option.hasAttribute('selected')) && !showOption) {
          selectedOptionIsVisible = false;
          option.selected = false;
          option.removeAttribute('selected');
        }
      });

      if (selectedOptionIsVisible) return;

      const nextOption = getVisibleOptions(select)[0];
      if (!nextOption) return;

      selectOption(select, nextOption);
    });
  }

  function selectFirstVisibleOption(session) {
    let changed = false;
    const selects = session.controlsWrapper.querySelectorAll('select');

    selects.forEach((select) => {
      const firstOption = getVisibleOptions(select)[0];
      if (!firstOption) return;

      changed = selectOption(select, firstOption) || changed;
    });

    return changed;
  }

  function syncSelectedVariant(session) {
    const selectedOptions = Array.from(session.controlsWrapper.querySelectorAll('select'))
      .map((select) => select.selectedOptions[0])
      .filter(Boolean);
    const selectedOptionValueIds = selectedOptions.map((option) => option.dataset.optionValueId).filter(Boolean);
    const selectedOptionValues = selectedOptions.map((option) => option.value);

    if (selectedOptionValueIds.length === 0 && selectedOptionValues.length === 0) return;

    const selectedVariant = getVariantData(session).find((variant) => {
      const variantOptionValueIds = Array.isArray(variant.optionValueIds) ? variant.optionValueIds.map(String) : [];
      const variantOptions = Array.isArray(variant.options) ? variant.options.map(String) : [];
      const matchesOptionValueIds =
        selectedOptionValueIds.length > 0 &&
        selectedOptionValueIds.every((optionValueId) => variantOptionValueIds.includes(String(optionValueId)));
      const matchesOptionValues =
        selectedOptionValues.length > 0 &&
        selectedOptionValues.every((optionValue, index) => variantOptions[index] === String(optionValue));

      return matchesOptionValueIds || matchesOptionValues;
    });

    if (!selectedVariant) return;

    session.controlsWrapper.querySelectorAll('form input[name="id"], form .product-variant-id').forEach((input) => {
      input.disabled = false;
      input.value = selectedVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function resetCalendarWidget(session) {
    const appModal = getAppModal();
    if (!appModal) return;

    const controlsWrapper = session.controlsWrapper;
    Array.from(appModal.children).forEach((child) => {
      if (child === controlsWrapper) return;
      child.remove();
    });

    mountControlsAboveAppModal(appModal, controlsWrapper);

    if (!appModal.querySelector(WIDGET_SELECTOR)) {
      const widget = document.createElement('div');
      widget.id = WIDGET_SELECTOR.slice(1);
      appModal.append(widget);
    }
  }

  function getSubmitButton(session) {
    return session.controlsWrapper.querySelector('product-form [type="submit"]');
  }

  function enableCalendarButton(session) {
    if (!session.appButton) return;

    session.appButton.disabled = false;
    session.appButton.removeAttribute('disabled');
    session.appButton.removeAttribute('aria-disabled');
    session.appButton.classList.remove('disabled');
  }

  function clickCalendarButtonWhenReady(session, attempt = 0) {
    if (activeSession !== session) return;
    if (!session.appButton) return;

    enableCalendarButton(session);
    syncSelectedVariant(session);

    const submitButton = getSubmitButton(session);
    if (submitButton && submitButton.disabled && attempt < 20) {
      window.setTimeout(() => clickCalendarButtonWhenReady(session, attempt + 1), 100);
      return;
    }

    prepareAppModalRootsToOpen();
    resetCalendarWidget(session);
    waitingForAppModal = true;
    holdControlsInAppModal();
    session.appButton.click();
  }

  function openSelectedCalendar(session) {
    window.setTimeout(() => {
      if (activeSession === session) {
        applyOptionVisibility(session);
        selectFirstVisibleOption(session);
      }
    }, 300);

    window.setTimeout(() => {
      clickCalendarButtonWhenReady(session);
    }, 350);
  }

  function scheduleCalendarReload(session) {
    if (activeSession !== session) return;

    const appModalRoot = session.controlsWrapper.closest(`.cowlendar-bg.cowlendar-root.${APP_MODAL_REQUESTED_CLASS}`);
    if (!appModalRoot) return;

    window.clearTimeout(session.calendarReloadTimer);
    session.calendarReloadTimer = window.setTimeout(() => {
      if (activeSession !== session || !session.controlsWrapper.closest(`.${APP_MODAL_REQUESTED_CLASS}`)) return;
      clickCalendarButtonWhenReady(session);
    }, 100);
  }

  function prepareReservationSelects(variantSelects) {
    if (!variantSelects) return;

    variantSelects.querySelectorAll('.select').forEach((selectField) => {
      selectField.classList.add('field');

      selectField.querySelectorAll(':scope > .svg-wrapper, :scope > svg.icon-caret').forEach((caret) => caret.remove());

      if (selectField.querySelector(':scope > .icon')) return;

      const icon = document.createElement('span');
      icon.className = 'icon s_24 r';
      icon.setAttribute('aria-hidden', 'true');

      const symbol = document.createElement('span');
      symbol.className = 'material-symbols-rounded';
      symbol.textContent = 'keyboard_arrow_down';

      icon.append(symbol);
      selectField.append(icon);
    });
  }

  function initProductInfo(productInfo) {
    if (sessions.has(productInfo)) return;

    const controls = getProductControls(productInfo);
    if (!controls || !controls.appButton) return;

    /* MutationObserver経由で再実行されるため、途中で例外が起きても
       placeholder/ボタン挿入を無限に繰り返さないよう先にマークする。 */
    if (productInfo.dataset.originalReservationInitialized === 'true') return;
    productInfo.dataset.originalReservationInitialized = 'true';

    createCustomModal();

    const placeholder = document.createComment('cowlendar controls moved to custom modal');
    const controlsAnchor = controls.variantSelects || controls.productFormBlock;
    controlsAnchor.before(placeholder);

    const triggerMount = document.createElement('div');
    triggerMount.className = 'cowlendar-custom-open-wrap';
    const reservationAvailable = canOpenReservation(productInfo);
    triggerMount.hidden = false;

    const openButton = buildOpenButton(controls.appButton);
    triggerMount.append(openButton);
    placeholder.after(triggerMount);

    if (!reservationAvailable) {
      openButton.disabled = true;
      openButton.setAttribute('aria-disabled', 'true');
      openButton.classList.add('disabled');
    }

    const controlsWrapper = document.createElement('div');
    /* cowlendar_selectorクラスでv2 CSSのバーレイアウト（横並び・幅700px）を適用する */
    controlsWrapper.className = CONTROLS_CLASS + ' cowlendar_selector';
    if (controls.variantSelects) {
      prepareReservationSelects(controls.variantSelects);
      controlsWrapper.append(controls.variantSelects);
    }
    controls.productFormBlock.classList.add('cowlendar-product-form-block');
    controlsWrapper.append(controls.productFormBlock);
    customModalContent.append(controlsWrapper);

    const session = {
      productInfo,
      controlsWrapper,
      openButton,
      appButton: controls.appButton,
      variantData: null,
    };
    sessions.set(productInfo, session);
    applyOptionVisibility(session);

    if (reservationAvailable) {
      openButton.addEventListener('click', () => {
        openCustomModal(session);
      });
    }

    openHomeReservationWhenReady();
  }

  function openHomeReservationWhenReady() {
    if (!homeOpenRequested) return;

    const session = Array.from(sessions.values()).find(
      (candidate) => !homeReservationRequiresEligibleAccount || canOpenReservation(candidate.productInfo),
    );
    if (!session) return;

    homeOpenRequested = false;
    openCustomModal(session);
  }

  function init() {
    injectStyles();
    createCustomModal();
    observeAppModalRoots();
    document.querySelectorAll(`${ROOT_SELECTOR} ${PRODUCT_INFO_SELECTOR}`).forEach(initProductInfo);
  }

  document.addEventListener(
    'click',
    (event) => {
      const widgetCloseControl = getWidgetCloseControl(event.target);
      if (widgetCloseControl) {
        closeAppModalFromWidget(widgetCloseControl.closest(WIDGET_ROOT_SELECTOR));
        return;
      }

      const homeLink = event.target.closest('[data-original-reservation-link]');
      if (homeLink) {
        if (homeLink.hasAttribute('data-original-reservation-in-cart')) {
          event.preventDefault();
          if (typeof window.openModal === 'function') window.openModal('reservation_in_cart', homeLink);
          return;
        }

        const teaserModeEnabled = homeLink.dataset.originalReservationTeaserMode === 'true';

        /* ティザー状態では、ログイン済みの customer / employee だけ予約導線を利用可能にする。 */
        if (homeLink.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }

        const reservationRoots = Array.from(document.querySelectorAll(ROOT_SELECTOR));
        const hasAvailableRoot = reservationRoots.some((root) => {
          const loggedIn = root.dataset.customerLoggedIn === 'true';
          const accountType = (root.dataset.customerAccountType || '').trim().toLowerCase();
          return loggedIn && (accountType === 'customer' || accountType === 'employee');
        });

        if (teaserModeEnabled && reservationRoots.length > 0 && !hasAvailableRoot) {
          event.preventDefault();
          return;
        }

        event.preventDefault();
        homeReservationRequiresEligibleAccount = teaserModeEnabled;
        homeOpenRequested = true;
        openHomeReservationWhenReady();
        return;
      }

      const existingReservationLink = event.target.closest('[data-original-existing-reservation-link]');
      if (existingReservationLink) {
        event.preventDefault();
        if (typeof window.openModal === 'function') window.openModal('reservation_in_cart', existingReservationLink);
        return;
      }

      const existingReservationNew = event.target.closest('[data-existing-reservation-new]');
      if (existingReservationNew) {
        event.preventDefault();
        if (existingReservationNew.getAttribute('aria-disabled') === 'true') return;
        const teaserModeEnabled = existingReservationNew.dataset.originalReservationTeaserMode === 'true';
        clearExistingReservationAndProceed(teaserModeEnabled);
        return;
      }

      const appButton = event.target.closest(APP_BUTTON_SELECTOR);
      if (!appButton) return;

      const productInfo = appButton.closest(PRODUCT_INFO_SELECTOR);
      if (productInfo && !productInfo.closest(ROOT_SELECTOR)) return;

      activeSession = (productInfo && sessions.get(productInfo)) || findSessionByAppButton(appButton) || activeSession;
      if (!activeSession) return;

      applyOptionVisibility(activeSession);
      syncSelectedVariant(activeSession);
      enableCalendarButton(activeSession);
      prepareAppModalRootsToOpen();
      resetCalendarWidget(activeSession);
      waitingForAppModal = true;
      holdControlsInAppModal();
      scheduleMoveToAppModal();
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      if (event.target.tagName !== 'SELECT') return;

      const session = findSessionByNode(event.target);
      if (!session) return;

      applyOptionVisibility(session);
      syncSelectedVariant(session);
      scheduleCalendarReload(session);
    },
    true
  );

  const observer = new MutationObserver(() => {
    init();
    sessions.forEach(applyOptionVisibility);
    openHomeReservationWhenReady();

    const appModal = getAppModal();
    if (appModal && activeSession && shouldKeepControlsInAppModal()) {
      moveControlsToAppModal();
      return;
    }

    if (!appModal) {
      waitingForAppModal = false;
      keepControlsInAppModalUntil = 0;
      restoreControlsToCustomModal();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
